// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"27688":"ed09275e8ad2d8d8","47300":"064aa512cd13aa2c","69862":"68f3cb6b64edd139","84248":"03b6159bf7a8d49b"}[chunkId] + ".css";
};